import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync} from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';

class FormComp12 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global
            proveedor_sel: null,
            cedulaRuc: '',
            opt_estado: [{value: 'A', label: 'ACTIVO'}, {value: 'I', label: 'INACTIVO'}],
            estado_sel: null,

            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
        };

        this.limpiar = this.limpiar.bind(this);
        this.imprimir = this.imprimir.bind(this);
        this.changeComponents = this.changeComponents.bind(this);
    }

    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0612')
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0612');
    }

    imprimir(){
        try{
            let urlReportWithParams=`&rpt=91`;

            if(this.state.proveedor_sel){
                urlReportWithParams+=`&param1=${this.state.proveedor_sel.value}`;
            }

            if(this.state.cedulaRuc){
                urlReportWithParams+=`&param2=${this.state.cedulaRuc.toString().trim()}`;
            }

            if(this.state.estado_sel){
                urlReportWithParams+=`&param3=${this.state.estado_sel}`;
            }

            visualizarReporteEnPdf(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        this.setState({proveedor_sel: null, cedulaRuc: '', estado_sel: null,})
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Ficha de Proveedores</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Proveedor:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({proveedor_sel: value})}}/>
                        </ContainerCol>
                    </Row>  
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cédula:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                        <InputText name='cedulaRuc' value={this.state.cedulaRuc} type="number" className='form-control input-sm'  onChange={this.changeComponents}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Estado:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelect options={ this.state.opt_estado } value={this.state.estado_sel} func_onChange={(value)=>{this.setState({estado_sel: value!==null?value.value:null});}}/>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimir}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormComp12);